import { TitleSection, BreadCrumb, BottomSection } from 'components/generic';
import { useContext, useEffect, useState } from 'react';
import Table from './components/table';
import Images from 'assets/Images';
import { BatchUploadContext } from 'providers/bim-provider';
import ManualUpload from './components/manual-upload';
import { fileDownload } from 'utils';
import { useFetch } from 'hooks';

import './style.scss';

const BatchUpload = () => {
	const [tableScroll, setTableScroll] = useState(false);
	const [totalTableCount, setTotalTableCount] = useState(0);
	const context = useContext(BatchUploadContext);
	const { tableHeaders, tableData, createObj, pageNumber, setPageNumber, setTableHeaders, setTableData, reset } = context;
	const api = useFetch();

	// api to get data for audit
	const getAudit = async e => {
		const payload = { filter: [], sort: [e || { id: 'updatedAt', value: -1 }], start_index: e ? 0 : pageNumber, record_count: e ? pageNumber + 20 : 20, search_value: '' };
		const res = await api({ url: 'batchFileMapping/v1/audit', method: 'post', data: payload });

		if (res?.data?.data?.result) {
			setTableScroll(res?.data?.data?.result?.length > 0);
			setTotalTableCount(res?.data?.data?.total);
			setTableData(prevState => (e ? res?.data?.data?.result : prevState.concat(res?.data?.data?.result)));
		} else {
			setTableScroll(false);
		}
	};

	// api to Upload File
	const uploadFile = async () => {
		const form = new FormData();
		form.append('c_id', localStorage.getItem('c_id'));
		form.append('p_code', createObj?.p_code);
		form.append('bfm_uploadLoadType', createObj?.bfm_uploadLoadType);
		form.append('uploadFrom', createObj?.uploadFrom ? 'SERVER' : 'APPLICATION');
		form.append('mode', 'MANUAL');
		form.append('bfm_loadCode', createObj?.bfm_loadCode);
		form.append('bfm_version', createObj?.bfm_version);
		form.append('file', createObj?.file);

		await api({ url: 'batchFileMapping/v1/import', method: 'post', data: form });
		reset();
		getAudit();
	};

	// batchFileMapping for listing API Call
	const batchFileMapping = async () => {
		const res = await api({ url: 'batchFileMapping/v1', method: 'post' });
		context.mappingData(res?.data?.data[0]?.result);
		reset();
	};

	// api to download file
	const downloadAudit = async (type, id) => {
		const res = await api({ url: `batchFileMapping/v1/downloadAudit?type=${type?.toUpperCase()}&ufl_uploadBatchId=${id}`, method: 'get', data: { type: type?.toUpperCase(), ufl_uploadBatchId: id } });
		fileDownload(res?.data?.data?.bfm_bufferData?.data, type);
	};

	// calling api to get data for audit header
	const auditRefer = async () => {
		const res = await api({ url: 'gridStructure/v1/BATCH_UPLOAD_AUDIT', method: 'get' });
		setTableHeaders(res?.data?.data[0]?.columns);
	};

	useEffect(() => {
		auditRefer();
		batchFileMapping();
	}, []);

	useEffect(() => {
		totalTableCount >= pageNumber && getAudit();
	}, [pageNumber]);

	const handelPageScrollNo = pageNo => {
		setPageNumber(prevState => prevState + pageNo);
	};

	const handleBottomSection = e => {
		e === 'Goback' && reset();
		e === 'Save' && uploadFile();
		getAudit();
	};

	return (
		<>
			{!context.uploadState && (
				<>
					<TitleSection title='Upload List' count={totalTableCount} />
					<Table tableHeader={tableHeaders} tableData={tableData} handleFile={downloadAudit} handleSort={getAudit} handleScroll={handelPageScrollNo} scrollEvent={tableScroll} />
					<div className='upload'>
						<img src={Images.upload} alt='upload' onClick={() => context.setUploadState(true)} />
					</div>
				</>
			)}
			{context.uploadState && (
				<>
					<BreadCrumb path={['Batch Upload', 'Manual Upload']} />
					<ManualUpload />
					<BottomSection handleButtonClick={handleBottomSection} disableSave={!createObj?.bfm_loadCode || !createObj?.p_code || (!createObj?.uploadFrom && !createObj?.file)} />
				</>
			)}
		</>
	);
};

export default BatchUpload;
